import React from 'react';
import { Link } from 'gatsby';
import 'twin.macro';

import CaretRight from '~components/Svg/CaretRight';

import type { LinkProps } from './index';
import { linkStyles } from './styles';

const InternalLink: React.FC<LinkProps> = ({ to, children, ...rest }) => (
  <Link to={to} css={linkStyles} {...rest}>
    <span>{children}</span>
    <CaretRight tw="h-4 w-auto" />
  </Link>
);

export default InternalLink;
